import { HELPERS } from '@/utils';
import http, { getAuthConfig } from './http';

const BASE_URL = '/search';

const getCatalog = (query = '', callback) => {
  http
    .get(`${BASE_URL}${query}`, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const getCatalogsWithQuery = async ({ queryKey }) => {
  const queries = HELPERS.objectToQueryString(queryKey[1]);
  return http
    .get(`${BASE_URL}${queries}`, getAuthConfig())
    .then((res) => res.data.payload)
    .catch(() => {
      HELPERS.showNotificationServiceError('Terjadi Kesalahan');
    });
};

const getCatalogsInfiniteWithQuery = async ({ queryKey, pageParam }) => {
  const queries = HELPERS.objectToQueryString({ ...queryKey[1], page: pageParam });
  return http
    .get(`${BASE_URL}${queries}`, getAuthConfig())
    .then((res) => {
      const data = res.data.payload;
      if (queryKey[1].item_type === 'event') {
        return data.events;
      }
      return data.courses;
    })
    .catch((error) => {
      HELPERS.showNotificationServiceError('Terjadi Kesalahan');
      throw error;
    });
};

const generateQueryKeys = ({ query, priceMin, priceMax, categoryId, perPage, itemType, authDependentKey }) => {
  return [
    'catalogs',
    {
      query,
      price_min: priceMin,
      price_max: priceMax,
      category_id: categoryId,
      per_page: perPage,
      item_type: itemType,
      auth_status: authDependentKey,
    },
  ];
};

export const SERVICE_CATALOG = {
  getCatalog,
  getCatalogsWithQuery,
  generateQueryKeys,
  getCatalogsInfiniteWithQuery,
};
